import { FC } from 'react';
import Embedly from '../files/Embedly';
import { Button } from 'antd';

interface ObjectiveAIMediaProps {
  url: string;
  description: string;
  time: number;
  onAdd: () => void;
  onRemove?: () => void;
}

const calculateHours = (time: number) => {
  const hours = Math.floor(time / 60);

  if (time === 60) {
    return `${hours} hour`;
  }

  if (time > 60) {
    return `${hours} hours`;
  }

  return `${time} minutes`;
};

const ObjectiveAIMedia: FC<ObjectiveAIMediaProps> = ({
  url,
  description,
  time,
  onAdd,
  onRemove,
}) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Embedly data={{ url, description: url }} />
      <p style={{ textAlign: 'center' }}>
        <b>Description: </b>
        {description}
      </p>
      <p style={{ textAlign: 'center' }}>
        <b>Time: </b>
        {calculateHours(time)}
      </p>
      <p style={{ textAlign: 'center' }}>
        <a href={url} target="_blank" rel="noreferrer">
          Visit url
        </a>
        &nbsp;&nbsp;&nbsp;
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        <Button type="primary" onClick={onAdd}>
          Accept
        </Button>
        <Button danger onClick={onRemove}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default ObjectiveAIMedia;
